"use client"

import { useState, useEffect } from "react"
import { RotateCcw } from "lucide-react"

// Add custom styles for the animation
const styles = `
@keyframes spinLeft {
  0% {
    transform: rotate(0deg);
  }
  90% {
    transform: rotate(-360deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}

.spin-left {
  animation: spinLeft 0.5s cubic-bezier(0.3, 0, 0.2, 1);
}
`

interface ClearHistoryButtonProps {
  onClear: () => Promise<void>
  disabled?: boolean
}

export default function ClearHistoryButton({ onClear, disabled }: ClearHistoryButtonProps) {
  const [isSpinning, setIsSpinning] = useState(false)

  // Add style tag to the document
  useEffect(() => {
    const styleTag = document.createElement('style')
    styleTag.textContent = styles
    document.head.appendChild(styleTag)
    return () => styleTag.remove()
  }, [])

  const handleClick = async () => {
    if (isSpinning) return // Prevent multiple clicks during animation
    setIsSpinning(true)
    try {
      await onClear()
    } finally {
      // Match the animation duration
      setTimeout(() => setIsSpinning(false), 500)
    }
  }

  return (
    <button
      onClick={handleClick}
      className="p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors"
      disabled={disabled || isSpinning}
    >
      <RotateCcw className={`w-5 h-5 text-gray-400 ${isSpinning ? 'spin-left' : ''}`} />
    </button>
  )
}
